'use strict';

var React = require('react');

var TabBar = require('../molecules/TabBar'),
    TabRouterLink = require('../atoms/TabRouterLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var HomeNavHeader = React.createClass({
  mixins: [PureRenderMixin],

  render: function () {
    return (
      <TabBar context='NavBar'>
        <TabRouterLink to='feed'>
          My Feed
        </TabRouterLink>
        <TabRouterLink to='zines'>
          Collections
        </TabRouterLink>
      </TabBar>
    );
  }
});

module.exports = HomeNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/HomeNavHeader.jsx
 **/